// Reordering the activity list.
//
// Shared by the Basic Planner and the AI Prompt page so a row behaves the same
// on both, and pure so the behaviour can be asserted without a DOM.

/**
 * Insert a new activity directly below the one at `index`.
 *
 * Adding always appended before, which is wrong for the button it is on: the
 * "+" sits in a row, so it means "another one here" — an instructor filling in
 * the middle of a lesson had to add at the end and then drag it back up.
 */
export const insertActivityAfter = (activities, index, blank) => {
  const list = Array.isArray(activities) ? [...activities] : [];
  // An index that is out of range (or missing) appends, which is what a button
  // outside any row would mean.
  const at = Number.isInteger(index) && index >= 0 && index < list.length ? index + 1 : list.length;
  list.splice(at, 0, blank);
  return list;
};

/**
 * Move the activity at `from` to sit at `to`, closing the gap behind it —
 * the behaviour of dragging a row onto another row.
 */
export const moveActivity = (activities, from, to) => {
  const list = Array.isArray(activities) ? [...activities] : [];
  if (!Number.isInteger(from) || !Number.isInteger(to)) return list;
  if (from < 0 || from >= list.length) return list;
  if (to < 0 || to >= list.length || from === to) return list;
  const [moved] = list.splice(from, 1);
  list.splice(to, 0, moved);
  return list;
};

/** Remove an activity, never leaving the list empty. */
export const removeActivityAt = (activities, index) => {
  const list = Array.isArray(activities) ? [...activities] : [];
  if (list.length <= 1) return list;
  if (!Number.isInteger(index) || index < 0 || index >= list.length) return list;
  return list.filter((_, i) => i !== index);
};
